const animationGalleryHoverEffect = () => {
	if (window.matchMedia('(pointer: coarse)').matches) {
		return;
	} else {
		const figures = document.querySelectorAll('.gallery-figure');

		if (figures.length) {
			for (let figure of figures) {
				let caption = figure.querySelector('.gallery-caption');

				let tl = gsap.timeline({ paused: true, reversed: true });

				tl.from(caption, 0.3, { opacity: 0, y: 100 });

				figure.onmouseenter = function () {
					tl.play();
				};

				figure.onmouseleave = function () {
					tl.reverse();
				};
			}
		}
	}
};

export default animationGalleryHoverEffect;
